/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SortDirection } from '../../models/sort-direction';
import { UserList } from '../../models/user-list';
import { UserSortFieldName } from '../../models/user-sort-field-name';

export interface GetUsers$Params {

/**
 * Indicates the field to use for sorting the data:
 *   * DATE : the date
 *   * LOGIN : the login
 *   * LAST_NAME : the last name
 *   * FIRST_NAME : the first name
 *   * PROVIDER : the provider
 */
  sortFieldName?: UserSortFieldName & any;

/**
 * Sort direction : ASC, DESC
 */
  sortDirection?: SortDirection & any;

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * Indicates whether to return only the users with an ACTIVE status
 */
  onlyActiveFilter?: boolean;
}

export function getUsers(http: HttpClient, rootUrl: string, params?: GetUsers$Params, context?: HttpContext): Observable<StrictHttpResponse<UserList>> {
  const rb = new RequestBuilder(rootUrl, getUsers.PATH, 'get');
  if (params) {
    rb.query('sortFieldName', params.sortFieldName, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('onlyActiveFilter', params.onlyActiveFilter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserList>;
    })
  );
}

getUsers.PATH = '/users';
